// export const api_url = "http://localhost:8000/"
// export const media_url = "http://localhost:8000/"
export const api_url = "https://apianell.rxultimate.com/"
export const media_url = "https://apianell.rxultimate.com"